<template>
<div id="app"
  class="wrapper">
  <header class="header"
    v-show="!needsFullScreen">
    <div class="container">
      <nav class="header-nav">
        <div class="logo">
          <router-link v-bind:to="{name: 'home'}">
            <img class="logo-max"
              src="/common/images/logo.svg"
              alt="創業のための事業計画書サービス 3kyaku（サンキャク）">
            <img class="logo-min"
              src="/common/images/logo-icon.svg"
              alt="創業のための事業計画書サービス 3kyaku（サンキャク）">
          </router-link>
        </div>
        <div class="header-link">
          <div v-if="!$firebase.user"
            class="user-logged-out">
            <ul class="guest">
              <li>
                <router-link v-bind:to="{name: 'signin'}">
                  <Button type="primary">新規登録</Button>
                </router-link>
              </li>
              <li>
                <router-link v-bind:to="{name: 'login'}">
                  <Button>ログイン</Button>
                </router-link>
              </li>
            </ul>
          </div>
          <div v-else
            class="user-logged-in">
            <router-link v-bind:to="{name: 'requestConsultation'}"
              v-if="isDevelopment">
              <Button>依頼入力</Button>
            </router-link>
            <router-link v-bind:to="{name: 'consultationHistoryList'}"
              v-if="isDevelopment">
              <Button>ユーザー側履歴一覧</Button>
            </router-link>
            <router-link v-bind:to="{name: 'consultationCaseList'}"
              v-if="isDevelopment">
              <Button>専門家側履歴一覧</Button>
            </router-link>
            <!--
            <router-link v-bind:to="{name: 'consultationHistoryList'}"
              v-if="isDevelopment">
              <Button>ユーザーの申し込み一覧</Button>
            </router-link>
            <router-link v-bind:to="{name: 'consultationCaseList'}"
              v-if="isDevelopment">
              <Button>せんもんかよう</Button>
            </router-link>
          -->
            <router-link v-bind:to="{name: 'planList'}"
              class="header-link-create">
              <Button type="primary">事業計画書一覧</Button>
            </router-link>
            <Poptip v-model="visible">
              <a>
                <Button type="text">
                  {{ $firebase.user.displayName }}
                  <Icon type="ios-arrow-down"></Icon>
                </Button>
              </a>
              <!-- <div slot="title">
                    <i>メニュー</i>
                  </div> -->
              <div slot="content"
                class="action-menu">
                <ul>
                  <!-- <li>
                    <router-link v-bind:to="{name: 'config'}">設定</router-link>
                  </li> -->
                  <li>
                    <router-link v-bind:to="{name: 'planList'}">事業計画書一覧</router-link>
                  </li>
                  <li>
                    <a @click="signOut">ログアウト</a>
                  </li>
                </ul>
              </div>
            </Poptip>
          </div>
        </div>
      </nav>
    </div>
    <!-- <nav class="purpose-nav">
        <ul>
            <li><router-link v-bind:to="{name: 'learnList'}">書き方コンテンツ</router-link></li>
            <li><router-link v-bind:to="{name: 'simulate'}">返済シミュレーション</router-link></li>
            <li><router-link v-bind:to="{name: 'consultation'}">専門家に相談</router-link></li>
        </ul>
      </nav> -->
  </header>
  <div class="system-requirements">
    <div class="container">
      <p><strong>推奨環境のご案内</strong></p>
      <p>現在お使いのブラウザ（Internet Explorer）では、サービスの一部がうまく動作しない場合がございます。<br>
        推奨環境を確認の上、別のブラウザをご利用ください。</p>
      <Button v-bind:to="{name: 'helpPage'}">ヘルプを見る</Button>
    </div>
  </div>
  <router-view />
  <footer class="footer"
    v-show="!needsFullScreen">
    <div class="footer-inner">
      <div class="footer-item">
        <router-link v-bind:to="{name: 'home'}">
          <img class="footer-logo"
            src="/common/images/logo.svg"
            alt="創業のための事業計画書サービス 3kyaku（サンキャク）">
        </router-link>
        <div class="footer-description">
          3kyakuは創業のための事業計画書作成サービスです。事業計画書をつくるときの基礎を学んだり、融資に必要な項目や計算が揃った事業計画書を作成できます。
        </div>
        <div class="social-share">
          <ul>
            <li><a id="footer-social-share-twitter"
                href="http://twitter.com/intent/tweet?url=https://3kyaku.jp/&text=創業のための事業計画書3kyaku（サンキャク）&hashtags=3kyaku"
                rel="nofollow"
                target="_blank"><img src="/common/social-share/icon-twitter.svg" alt="Twiterでシェア"></a></li>
            <li><a id="footer-social-share-facebook"
                href="http://www.facebook.com/share.php?u=https://3kyaku.jp/"
                rel="nofollow"
                target="_blank"><img src="/common/social-share/icon-facebook.svg" alt="Facebookでシェア"></a></li>
            <li><a id="footer-social-share-hatena"
                href="http://b.hatena.ne.jp/add?mode=confirm&url=https://3kyaku.jp/&title=創業のための事業計画書3kyaku（サンキャク）"
                rel="nofollow"
                target="_blank"><img src="/common/social-share/icon-hatena.svg" alt="はてなブックマーク"></a></li>
            <li><a id="footer-social-share-line"
                href="http://line.me/R/msg/text/?創業のための事業計画書3kyaku（サンキャク） https://3kyaku.jp/"
                rel="nofollow"
                target="_blank"><img src="/common/social-share/icon-line.svg" alt="LINEに送る"></a></li>
          </ul>
        </div>
      </div>
      <div class="footer-item">
        <ul class="footer-menu">
          <li>
            <router-link v-bind:to="{name: 'learnList'}">事業計画書のキホン</router-link>
          </li>
          <li>
            <router-link v-bind:to="{name: 'supervisorPage'}">監修者プロフィール</router-link>
          </li>
          <li>
            <router-link v-bind:to="{name: 'interviewUenoPage'}">事業計画書の挑み方</router-link>
          </li>
          <li>
            <router-link v-bind:to="{name: 'simulate'}">事業資金シミュレーター</router-link>
          </li>
        </ul>
      </div>
      <div class="footer-item">
        <ul class="footer-menu">
          <!-- <li>
            <router-link v-bind:to="{name: 'howtoPage'}">使い方ガイド</router-link>
          </li> -->
          <li>
            <router-link v-bind:to="{name: 'termsPage'}">利用規約</router-link>
          </li>
          <li>
            <router-link v-bind:to="{name: 'helpPage'}">ヘルプ</router-link>
          </li>
          <li><a href="https://www.tnbank.co.jp/"
              target="_blank"
              rel="nofollow">運営会社</a></li>
        </ul>
      </div>
    </div>
    <div class="copyright">
      &copy;2021 tnbank Co., Ltd. All rights reserved.
    </div>
  </footer>
</div>
</template>
<!--<style lang="scss" src="@/assets/scss/style.scss"></style>-->
<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  computed: {
    needsFullScreen: function () {
      return (
        this.$route.name === 'editBasicPlan' ||
        this.$route.name === 'previewBasicPlan' ||
        this.$route.name === 'toCorrectConsultation' ||
        this.$route.name === 'correctionResult'
      )
    },
    isDevelopment: function () {
      return process.env.VUE_APP_MODE === 'development'
    }
  },
  methods: {
    show: function () {
      this.visible = true
    },
    signOut: function () {
      this.$firebase.signOutGapi()
    }
  }
}
</script>
